import { apiFetch, readJson } from './client';

export interface ClientOffboardingNotifyContact {
  id: number;
  name?: string | null;
  email: string;
  description?: string | null;
  isActive: boolean;
  createdBy: string;
  createdAt: string;
  modifiedBy: string;
  modifiedAt: string;
}

export interface ClientOffboardingNotifyContactUpsert {
  name?: string | null;
  email: string;
  description?: string | null;
  isActive: boolean;
}

const base = '/api/admin/client-offboarding-notify-contacts';

export async function listClientOffboardingNotifyContacts(): Promise<ClientOffboardingNotifyContact[]> {
  const res = await apiFetch(base);
  if (!res.ok) throw new Error(`List failed (${res.status})`);
  return readJson<ClientOffboardingNotifyContact[]>(res);
}

export async function createClientOffboardingNotifyContact(
  body: ClientOffboardingNotifyContactUpsert
): Promise<ClientOffboardingNotifyContact> {
  const res = await apiFetch(base, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Create failed (${res.status})`);
  }
  return readJson<ClientOffboardingNotifyContact>(res);
}

export async function updateClientOffboardingNotifyContact(
  id: number,
  body: ClientOffboardingNotifyContactUpsert
): Promise<ClientOffboardingNotifyContact> {
  const res = await apiFetch(`${base}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error((err as { errorText?: string }).errorText ?? `Update failed (${res.status})`);
  }
  return readJson<ClientOffboardingNotifyContact>(res);
}

export async function deleteClientOffboardingNotifyContact(id: number): Promise<void> {
  const res = await apiFetch(`${base}/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error(`Delete failed (${res.status})`);
}
